"use client";
import { useEffect, useState } from "react";
import Link from "next/link";

// Configuration for API
const CK = "ck_your_consumer_key_here";
const CS = "cs_your_consumer_secret_here";
const API_URL = "https://alshakilee.com/wp-json/wc/v3/products";

export default function ShopPage() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Fetch products. We filter for 'status=publish'
    fetch(`${API_URL}?consumer_key=${CK}&consumer_secret=${CS}&status=publish`)
      .then((res) => res.json())
      .then((data) => {
        setProducts(data);
        setLoading(false);
      })
      .catch((err) => console.error("Error fetching shop products:", err));
  }, []);

  return (
    <div className="min-h-screen bg-white text-black font-sans">
      {/* Page Header */}
      <header className="py-16 px-8 border-b border-gray-100">
        <div className="max-w-7xl mx-auto">
          <h1 className="text-5xl font-black uppercase tracking-tighter italic">Ready-to-Wear</h1>
          <p className="text-gray-500 mt-4 max-w-md">
            Expertly crafted garments, tailored to our signature blocks and ready for immediate delivery.
          </p>
        </div>
      </header>

      {/* Product Grid */}
      <main className="max-w-7xl mx-auto px-8 py-12">
        {loading ? (
          <div className="flex justify-center items-center h-64">
             <div className="w-8 h-8 border-4 border-black border-t-transparent rounded-full animate-spin"></div>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
            {products.map((product: any) => (
              <div key={product.id} className="group relative flex flex-col">
                <div className="aspect-[3/4] overflow-hidden bg-gray-100 relative rounded-lg">
                  <img
                    src={product.images[0]?.src || "https://via.placeholder.com/600x800"}
                    alt={product.name}
                    className="object-cover w-full h-full group-hover:scale-105 transition-transform duration-700"
                  />
                  {/* Hover Overlay */}
                  <div className="absolute inset-0 bg-black/5 opacity-0 group-hover:opacity-100 transition-opacity" />
                  
                  <Link 
                    href={`https://alshakilee.com/product/${product.slug}`}
                    className="absolute bottom-4 left-4 right-4 bg-white text-black text-center py-3 font-bold uppercase text-xs opacity-0 group-hover:opacity-100 translate-y-4 group-hover:translate-y-0 transition-all duration-300 shadow-xl"
                  >
                    Quick View
                  </Link>
                </div>

                <div className="mt-6 flex justify-between items-start">
                  <div>
                    <h3 className="text-sm font-bold uppercase tracking-wider">{product.name}</h3>
                    <p className="text-gray-400 text-xs mt-1 uppercase">
                      {product.categories[0]?.name || "Collection"}
                    </p>
                  </div>
                  <p className="font-bold text-lg">OMR {product.price}</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </main>
    </div>
  );
}